import { OtherTheme, Theme } from '@toggle/toggle';
import { useTranslation } from 'react-i18next';

export const isTheme = (item: Theme | OtherTheme): item is Theme => {
  return 'theme_id' in item;
};

export const useThemeTypeColors = () => {
  const { t } = useTranslation(['earnings']);

  return {
    [t('earnings:earningsInsight.drawer.investmentTheme')]: 'var(--kg-theme)',
    Financial: 'var(--text-decorative-purple)',
    Macro: 'var(--text-decorative-teal)',
  };
};
